function requireAll(r) {
    r.keys().forEach(r);
}

requireAll(require.context('../../Images/UserArea/svg/', true, /\.svg$/));